export default {
    SCROLL_OFFSET: 250,
};
